import React from 'react';

const BACKEND_URL = '';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] UI_CRASH', error, info);
    fetch(`${BACKEND_URL}/api/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        route: window.location.pathname,
        message: String(error?.message || error),
        stack: String(error?.stack || ''),
        component_stack: String(info?.componentStack || ''),
        timestamp: new Date().toISOString(),
      }),
    }).catch(() => {});
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, maxWidth: 480, margin: '80px auto', fontFamily: 'system-ui, sans-serif' }}>
          <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: 24 }}>
            <h2 style={{ margin: '0 0 8px', color: '#991b1b', fontSize: 18 }} data-testid="error-boundary-title">
              Something went wrong
            </h2>
            <p style={{ margin: '0 0 16px', color: '#7f1d1d', fontSize: 14 }}>
              An unexpected error occurred on <strong>{window.location.pathname}</strong>
            </p>
            <button
              data-testid="error-boundary-reload-btn"
              onClick={() => window.location.reload()}
              style={{
                background: '#dc2626', color: 'white', border: 'none', borderRadius: 8,
                padding: '8px 20px', cursor: 'pointer', fontSize: 14, fontWeight: 600,
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
